import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import Plot from "react-plotly.js";
import React, {useEffect, useState} from "react";
import {
    getBoxplotAnalyze,
    getConfusionMatrix,
    getFeatureImportancePlot,
    getHistogramplot,
    getScatterplotAnalyze,
    getScatterplotTime,
    getAFSHeatmap, getScatterplotAFS
} from "../utils/plotting";

function Plotting(props) {
    const [plotData, setPlotData] = useState([])
    const [plotLayout, setPlotLayout] = useState({})

    const theme = useTheme();
    const {t} = useTranslation();

    const plotGenerators = {
        boxAnalyze: getBoxplotAnalyze,
        scatterAnalyze: getScatterplotAnalyze,
        confusionMatrixVal: getConfusionMatrix,
        confusionMatrixTrain: getConfusionMatrix,
        scatterTime: getScatterplotTime,
        histogram: getHistogramplot,
        featureImportance: getFeatureImportancePlot,
        AFSHeatmap: getAFSHeatmap,
        AFSScatter: getScatterplotAFS
        // Add more plot types and their corresponding generator functions
    };

    const generatePlot = () => {
        const {type} = props;
        const plotGenerator = plotGenerators[type];
        if (plotGenerator) {
            const plot = plotGenerator(props, t, theme);
            setPlotLayout(plot[1]);
            setPlotData(plot[0]);
        }
    };

    useEffect(() => {
        generatePlot();
    }, [props.type, props.runData]);

    return (
        <>
            {plotData.length > 0 ?
                <Plot
                    data={plotData}
                    layout={plotLayout}
                /> : ""}
        </>
    );
}

export default Plotting